import axios from 'axios';
import { getBackendBaseUrl } from './apiUrls';

const billingBase = `${getBackendBaseUrl()}/billing`;

export async function fetchGuestUpgradeOffer() {
  const res = await axios.get(`${billingBase}/public/pricing`);
  const payload = res.data || {};
  const configs = Array.isArray(payload.product_configs) ? payload.product_configs : [];
  const planNames = configs
    .map((cfg) => cfg.display_name)
    .filter(Boolean);
  const freeTrialDeals = payload.default_free_trial_deals ?? 1;
  return { freeTrialDeals, planNames };
}

export function formatGuestPlanChoices(planNames) {
  const names = (planNames || []).filter(Boolean);
  if (names.length === 0) {
    return 'a Part-Time Agent or Full-Time Agent plan';
  }
  if (names.length === 1) {
    return `the ${names[0]} plan`;
  }
  return `the ${names.slice(0, -1).join(', ')} or ${names[names.length - 1]} plan`;
}

export function formatFreeTrialOffer(freeTrialDeals) {
  const count = Number(freeTrialDeals);
  if (!Number.isFinite(count) || count <= 0) {
    return 'free transactions';
  }
  return `${count} free transaction${count === 1 ? '' : 's'}`;
}
